import type { FaireProductEntity } from "../../entity_types/product";

export const p_x3cuyvze66: FaireProductEntity = {
  token: "p_x3cuyvze66",
  type: "product",
  name: "OVERSIZED BOIFRIEND T-SHIRT IN HEATHER STRIPE",
  brandToken: "b_9jdg5bykvm",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/127798d988541a473ce98db1e20a82ed0ba64a8851ab72a03cfc8f887afe21db.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d7f076fa07a49d91a476b8f5601fce88e7c3545ea172b64771c7a626aa6062e9.jpeg",
    "https://cdn.faire.com/fastly/a43b6d11a91c2c8321bcbc20b6c3b63f42b885157b3dd744adb34ec2376eeb50.jpeg",
    "https://cdn.faire.com/fastly/b2cd421c9b521591a353047f1279646b1bbd19fab23600035240673a5d62f140.jpeg",
    "https://cdn.faire.com/fastly/536b6c5085f5097f9928b36a2ac974a1c3422d13b6984d9d77fcd903567a43c6.jpeg",
    "https://cdn.faire.com/fastly/817c34266a9b5adfba0c0afd22d5933e34d72d049863097e92d2f871a0ad53c2.jpeg",
  ],
  priceDollars: 44.34,
  description:
    "The Boifriend T-Shirt is an easy everyday staple with a relaxed, oversized fit. Made from a lightweight cotton blend, it features a boxy silhouette, pre-rolled sleeves, and a playful stripe pattern with a pop of color. Comfortable and versatile, it’s designed to be worn again and again. Ethically made in Los Angeles.\n\n * Oversized, boxy fit \n * Pre-rolled sleeves\n\n * Lightweight cotton\n\n * Ethically made in Los Angeles ",
  tags: [],
  msrpDollars: 88.68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:50.651Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
